import React from "react";
import { Link } from "react-router-dom";
import { Phone, FileText } from "lucide-react";
import { brand } from "../data/site";

// Fixed call / estimate bar on phones only. Hidden from md up, where the
// header already shows the phone number and Free Estimate button.
// No text option: the office line takes calls only, and an sms: link that
// goes nowhere costs more than it saves.
const MobileCallBar = () => (
  <div
    className="md:hidden fixed bottom-0 inset-x-0 z-50 bg-ink/95 backdrop-blur border-t border-brand/30"
    style={{ paddingBottom: "env(safe-area-inset-bottom, 0px)" }}
  >
    <div className="grid grid-cols-2 divide-x divide-white/10">
      <a href={`tel:${brand.phoneRaw}`} className="flex flex-col items-center justify-center gap-1 py-3 text-white active:bg-white/10">
        <Phone size={18} className="text-brand" />
        <span className="text-[11px] font-semibold uppercase tracking-wider">Call</span>
      </a>
      <Link to="/contact" className="flex flex-col items-center justify-center gap-1 py-3 bg-brand text-ink active:brightness-95">
        <FileText size={18} />
        <span className="text-[11px] font-semibold uppercase tracking-wider">Free Estimate</span>
      </Link>
    </div>
  </div>
);

export default MobileCallBar;
